import React from "react";
import { createSvgIcon } from "@mui/material/utils";
const Line = createSvgIcon(/*#__PURE__*/React.createElement("path", {
  d: "M15.5 0.5H0.5C0.223877 0.5 0 0.723877 0 1C0 1.27612 0.223877 1.5 0.5 1.5H15.5C15.7761 1.5 16 1.27612 16 1C16 0.723877 15.7761 0.5 15.5 0.5Z"
}), "Line");
export default Line;